<div class="page-selection">
  <ul class="selection">
    <li (click)="onFirstPageClicked()" [ngClass]="{'disabled': page <= 1}">
      <i class="material-icons">first_page</i>
    </li>
    <li (click)="onPreviousPageClicked()" [ngClass]="{'disabled': page <= 1}">
      <i class="material-icons">chevron_left</i>
    </li>
    <li (click)="onPageNumberClicked(item)" *ngFor="let item of paginatorRange"
        [ngClass]="{'active': item === page}">
      <span class="page-number">{{item}}</span>
    </li>
    <li (click)="onNextPageClicked()" [ngClass]="{'disabled': page >= totalPages}">
      <i class="material-icons">chevron_right</i>
    </li>
    <li (click)="onLastPageClicked()" [ngClass]="{'disabled': page >= totalPages}">
      <i class="material-icons">last_page</i>
    </li>
  </ul>
</div>
<div *ngIf="!hideEntrySelection" class="entry-selection">
  <p class="pag">Results per page</p>
  <mat-select (selectionChange)=onPageSizeChanged($event) [value]="size">
    <mat-option *ngFor="let entrySize of entryRange" [value]="entrySize">{{entrySize}}</mat-option>
  </mat-select>
</div>
